import { SET_MAP_DIMENSIONS } from './types';

export const setMapDimensions = (pathSpaceId, dimensions) => ({
  payload: {
    dimensions,
    pathSpaceId,
  },
  type: SET_MAP_DIMENSIONS,
});
